import React from 'react'
import {
  Row,
  Col,
} from "react-bootstrap";
import TooltipDesc from "./TooltipDesc";

function HistoryOfItemForWaranty({ itemtransactions, item, typeOfModalWaranty }) {
  const headerOfhistory = ["نوع تراکنش", "شرکت", "اپراتور", "مبلغ ", "تاریخ ", "ساعت ", "تاریخ ثبت"]

  return (
    <>
      <div>
        {typeOfModalWaranty == "CancelStatus" && !!item.amusementServiceReserveItemTicketSourceId &&
          <div
            style={{
              borderBottom: "1px solid black"
            }}
            className="pb-3 mb-3 pe-5"
          >
            - وضعیت منبع بلیط به <strong>{item.strStatus}</strong> تغییر یافته است.
        </div>
        }
        {itemtransactions && itemtransactions.length > 0 ?
          <div className='py-2 rounded-4' style={{ backgroundColor: "rgba(0, 0, 0, 0.04)", borderRadius: "5px" }}>
            <Row className='mt-1'>
              {headerOfhistory.map((head, key) => {
                return <Col key={key}> <p className='text-center '>{head}</p></Col>
              })}
              <Col lg="1" className='px-3'> <p>توضیحات</p> </Col>
            </Row>
            <hr className='mx-2 my-0 mb-4 py-0' />
            {itemtransactions.map((i, key) => {
              return (<div key={key}>
                <Row>
                  <div className='d-flex justify-content-between align-items-center w-100 px-1' style={i.isDeleted ? { opacity: "0.5" } : { opacity: "1" }}>
                    <Col>  <p className='text-center '>{i.typeS}</p></Col>
                    <Col> <p className='text-center'>{i.supplierCompanyName}</p></Col>
                    <Col ><p className='text-center '>{i.createdByName}</p></Col>
                    <Col><p className='text-center ' style={i.typeS == 'دریافت_از_گارانتی_کننده' ? { color: "red" } : { color: "black" }}>{`${i.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}تومان`}</p></Col>
                    <Col><p className='text-center '>{i.completionDate}</p></Col>
                    <Col ><p className='text-center '>{i.completionTime}</p></Col>
                    <Col className='text-center' ><p >{i.created} </p> </Col>
                    <Col lg="1"><p className='text-center '>{i.isDeleted ? "حذف شده" : i.description != null && <TooltipDesc description={i.description} />}</p></ Col>
                  </div>
                </Row>
              </div>)
            })
            }
          </div>
          : <div className='p-5' style={{ backgroundColor: "rgba(0, 0, 0, 0.04)" }}> {typeOfModalWaranty == "payToWaranty" ? "لطفا مبلغ پرداختی خود را ثبت نمایید" : typeOfModalWaranty != "receiveFromWaranty" ? "تراکنشی ثبت نشده است" : "لطفا مبلغ دریافتی خود را ثبت نمایید"}</div>
        }</div>
    </>
  )
}

export default HistoryOfItemForWaranty